import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import "./EditSiteDataPolicySettings.html";

import EditSiteDataPolicySettingsComponentController from "./EditSiteDataPolicySettingsComponentController";

export default class EditSiteDataPolicySettingsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = EditSiteDataPolicySettingsComponentController;
        this.templateUrl = "/App/Components/Site/Overview/DataPolicy/EditDataPolicy/EditSiteDataPolicySettings.html";
    }
}

module("mmManagePortal").component("irEditSiteDataPolicySettings", new EditSiteDataPolicySettingsComponent());
